<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [draggable]="false"
    [header]="title"
    appendTo="body"
    [style]="{ 'max-width': '750px', width: '100%', 'max-height': '425px' }">
    <div class="mt-3">
        <ng-container *miproLoading="loadingEpisodes; diameterPx: '35px'">
            <div class="existing-episode" *ngFor="let item of episodes$ | async">
                <div class="flex">
                    <episode-header-v2
                        class="existing-episode-header mb-2"
                        [episode]="item"
                        [showPlusButton]="false"
                        [showEllipsisButton]="false">
                    </episode-header-v2>

                    <p-radioButton
                        *ngIf="operation === 'Merge'"
                        class="margin-left-15"
                        name="episode"
                        [value]="item.id"
                        [(ngModel)]="selectedEpisodeId"></p-radioButton>

                    <p-checkbox
                        *ngIf="operation === 'Unmerge'"
                        class="margin-left-15"
                        name="episode"
                        [value]="item.id"
                        [(ngModel)]="selectedEpisodeId"></p-checkbox>
                </div>
            </div>
        </ng-container>
    </div>

    <p-footer>
        <form-buttons [disabled]="isAcceptDisabled" [config]="buttonsConfig" [saving]="confirmInProgress"></form-buttons>
    </p-footer>
</p-dialog>
